export type { LoadRulesProps } from './load-rules';
export { default } from './load-rules';
